


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// // Models
import { TypeOfProduct } from '@/manager/product/models/product.model';
import BillLine from '@/manager/billing/models/bill-line.model';

// Components
import Field from '@/shared/components/field.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import FlatSelectorText, {
    FlatSelectorTextPredefinedStyle,
    FlatSelectorTextBorderBottom,
    FlatSelectorTextWeight,
} from '@/shared/components/FlatSelectorText.component.vue';
import NumberPicker, {
    NumberPickerColor,
    NumberPickerSize,
} from '@/shared/components/number-picker.component.vue';
import Input, {
    InputType,
    InputStyle,
    InputTextWeigth
} from '@/shared/components/input.component.vue';



@Component({
    components: {
        Field,
        FlatSelectorText,
        Icon,
        Input,
        NumberPicker,
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            getProduct: 'getProduct',
            productList: 'getProductList',
            currentBill: 'getCurrentBill',
            lastLineEmpty: 'currentBillHasLastLineEmpty',
        }),
    },
})
export default class ShoppingCartLineBill extends Vue {
    @Prop() private billLine!: any;
    @Prop({ default: false }) private modifyDataPrivate!: boolean;
    @Prop({ default: false }) private opened!: boolean;

    private iconEnum = IconEnum;
    private inputType = InputType;
    private inputStyle = InputStyle;
    private inputTextWeigth = InputTextWeigth;
    private flatSelectorTextBorderBottom = FlatSelectorTextBorderBottom;
    private flatSelectorTextWeight = FlatSelectorTextWeight;
    private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
    private numberPickerColor = NumberPickerColor;
    private numberPickerSize = NumberPickerSize;
    private productSelected: any = { label: '', value: '' };
    private productList!: any;
    private getProduct!: any;
    private currentBill!: any;
    private lastLineEmpty!: any;
    private currentPriceName!: any;
    private customPriceLine:boolean=false;


    get billHasProduct() {
        return this.billLine.product && this.billLine.product.id;
    }

    get billLineTotalPrice() {
        let price = 0;
        if (this.billHasProduct && this.billLine.productPrice) {
            price = this.billLine.productAmount * this.billLine.productPrice;
            const tax = ((this.billLine as any).product.tax + 100) / 100;
            this.billLine.totalPriceWithoutTax = price;
            price = price * tax;
            this.billLine.totalPrice = price;
        }
        return price;
    }

    get billLineProductPrice() {
        let price = 0;
        if (this.billHasProduct && this.billLine.productPrice) {
            // const tax = ((this.billLine as any).product.tax + 100) / 100;
            price = this.billLine.productPrice;
            // this.billLine.productPrice = price;
        }
        return price;
    }

    get currentPriceNameInitial() {
        let priceName:any = undefined;
        if (this.billLine.productPriceName && this.productPricesList.length > 0) {
            priceName = this.productPricesList.filter((objeto:any) => objeto.key === this.billLine.productPriceName);
        } else if (this.billLine.productPrice && this.productPricesList.length > 0){
            // Get product price name given the price
            priceName = this.productPricesList.filter((objeto:any) => objeto.value === this.billLine.productPrice);
            this.billLine.productPriceName = priceName[0].key
        }
        return priceName
    }

    get productPricesList() {
        let prices: any = [];
        if (!this.billHasProduct && this.billLine && this.billLine.product) {
            this.billLine.product = this.getProduct(this.billLine.product)
        }

        if (this.billHasProduct) {
            prices.push({ "key": "base", "name": "Base", "value": this.billLine.product.base || 0 });
            prices.push({ "key": "reserve", "name": "Reserve", "value": this.billLine.product.reserve || 0 });
            prices.push({ "key": "conference", "name": "Conference", "value": this.billLine.product.conference || 0 });
            prices.push({ "key": "fusion", "name": "Fusion", "value": this.billLine.product.fusion || 0 });
            prices.push({ "key": "webinar", "name": "Webinar", "value": this.billLine.product.webinar || 0 });
            prices.push({ "key": "course", "name": "Course", "value": this.billLine.product.course || 0 });
            prices.push({ "key": "bono", "name": "Bono", "value": this.billLine.product.bono || 0 });
            prices.push({ "key": "web", "name": "Web", "value": this.billLine.product.web || 0 });
            prices.push({ "key": "tlp", "name": "Tlp", "value": this.billLine.product.tlp || 0 });
            prices.push({ "key": "pwp", "name": "Pwp", "value": this.billLine.product.pwp || 0 });
            prices.push({ "key": "pPago ", "name": "P pago", "value": this.billLine.product.pPago || 0 });
            prices.push({ "key": "reEnroll ", "name": "Re enroll", "value": this.billLine.product.reEnroll || 0 });
            prices.push({ "key": "repeat", "name": "Repeat", "value": this.billLine.product.repeat || 0 });
            prices.push({ "key": "shuttle", "name": "Shuttle", "value": this.billLine.product.shuttle || 0 });
            prices.push({ "key": "ambassador", "name": "Ambassador", "value": this.billLine.product.ambassador || 0 });
            prices.push({ "key": "cn3", "name": "Cn3", "value": this.billLine.product.cn3 || 0 });
            prices.push({ "key": "conferenceInsurance", "name": "Conference insurance", "value": this.billLine.product.conferenceInsurance || 0 });
            prices.push({ "key": "price1", "name": "Price 1", "value": this.billLine.product.price1 || 0 });
            prices.push({ "key": "price2", "name": "Price 2", "value": this.billLine.product.price2 || 0 });
            prices.push({ "key": "price3", "name": "Price 3", "value": this.billLine.product.price3 || 0 });
            prices.push({ "key": "price4", "name": "Price 4", "value": this.billLine.product.price4 || 0 });
            prices.push({ "key": "price5", "name": "Price 5", "value": this.billLine.product.price5 || 0 });
            prices.push({ "key": "byHour", "name": "By hour", "value": this.billLine.product.byHour || 0 });
            prices.push({ "key": "custom", "name": "Personalizado", "value": 0 });
        }
        return prices;
    }

    get lineComplete() {
        return (
            this.billLine.product &&
            this.billLine.product.id &&
            (this.billLine as any).productAmount > 0
        );
    }


    private removeLine() {
        this.$emit('remove-line', this.billLine);
    }

    private addNewBillLine() {
        if (!this.lastLineEmpty) {
            this.$emit('new-line');
        }
    }

    private changeOption(option: any) {
        // this.billLine.productPrice = this.billLine.product.course
        // this.billLine.productPriceName = 'Course'
        // this.billLine.productAmount = 1;
        // this.billLine.productName = this.billLine.product.name;
        this.addNewBillLine();
    }

    private changeOptionPrice(option: any) {
        if (option.name == "Personalizado") {
            this.customPriceLine=true
        }
        this.currentPriceName = option
        this.billLine.productPrice = option.value
        this.billLine.productPriceName = option.key
        this.billLine.productAmount = 0;
        this.billLine.productName = this.billLine.product.name;
        this.billLine.productTax = this.billLine.product.tax
    }

    // private findKeyByValue(obj:any, value:any) {
    //     for (let key in obj) {
    //         if (obj.hasOwnProperty(key) && obj[key] === value) {
    //             return key;
    //         }    
    //     }
    //     return null; // Valor no encontrado
    // }

}
